export { EmissionsIcon } from './emissions'
